<div class="text asterisk">
    <svg-icon *ngIf="questionForm.controls.requierd.value" svgClass="svg-img-mini img" src="/assets/images/question-menu/asterisk.svg"></svg-icon>
    <div class="warp-rich-text" [ngClass]="isExpand?'isExpand':''" (click)="expandEditor(false)">
        <!-- placeholder="{{'questionBoard.edit.placeholder' | translate}}" -->
        <!-- (click)="$event.stopPropagation()" -->
        <que-rich-text [isText]="true" [isDisplay]="false" [isExpand]="isExpand" 
            [formControl]="questionForm.controls.additionalText"></que-rich-text>
    </div>
    <!-- [height]="isExpand?'70vh':''" [width]="isExpand?'60vw':''" -->
    <que-rich-text *ngIf="isExpand" placeholder="{{'questionBoard.edit.placeholder' | translate}}" [isText]="true"
        [formControl]="questionForm.controls.additionalText">
    </que-rich-text>
    
</div>